var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        {
          attrs: {
            title:
              "Servicios solicitados y su clasificación como costos indirectos"
          }
        },
        [
          _c("label", { staticClass: "data-label" }, [
            _vm._v(
              " Los servicios solicitar son considerados como parte de los costos indirectos reclamados o a reclamar por el DEPR "
            )
          ]),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ validated }) {
                  return [
                    _c("custom-radio", {
                      staticClass: "custom-radio",
                      attrs: {
                        "custom-error-msg": "El campo es requerido.",
                        disabled: _vm.isReadOnly,
                        "is-inline": "",
                        name: "indirectCost",
                        options: _vm.options
                      },
                      model: {
                        value: _vm.hasIndirectCosts,
                        callback: function($$v) {
                          _vm.hasIndirectCosts = $$v
                        },
                        expression: "hasIndirectCosts"
                      }
                    }),
                    validated &&
                    ![true, false].includes(_vm.hasIndirectCosts?.value)
                      ? _c("error", {
                          attrs: {
                            message: "El campo es requerido.",
                            variant: "no-border"
                          }
                        })
                      : _vm._e(),
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(
                        " (solo aplica a proyectos sufragados con fondos administrativos) "
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }